{
  "defaultLockedAccount": {
    "electronicFundsTransferInMessage": "Can't initiate a bank deposit from a registered income fund account.",
    "electronicFundsTransferOutMessage": "Can't initiate a direct withdrawal from a registered income fund account.",
    "internalTransferToMessage": "Please contact support to facilitate the transfer of funds"
  },
  "LIRA": {
    "electronicFundsTransferInMessage": "Can't initiate a bank deposit from a locked-in account.",
    "electronicFundsTransferOutMessage": "Please contact support to facilitate the transfer of funds",
    "internalTransferToMessage": "Please contact support to facilitate the transfer of funds"
  },
  "LRSP": {
    "electronicFundsTransferInMessage": "Can't initiate a bank deposit from a locked-in account.",
    "electronicFundsTransferOutMessage": "Please contact support to facilitate the transfer of funds",
    "internalTransferToMessage": "Please contact support to facilitate the transfer of funds"
  },
  "RLSP": {
    "electronicFundsTransferInMessage": "Can't initiate a bank deposit from a locked-in account.",
    "electronicFundsTransferOutMessage": "Please contact support to facilitate the transfer of funds",
    "internalTransferToMessage": "Please contact support to facilitate the transfer of funds"
  },
  "RRSP": {
    "electronicFundsTransferOutMessage": "RRSP transfers are usually either a transfer out to another RRSP account, withdrawing for a home buyers plan or transferring to a RRIF. Please contact support to facilitate the transfer of funds"
  },
  "RRSP_SPOUSAL": {
    "electronicFundsTransferOutMessage": "RRSP transfers are usually either a transfer out to another RRSP account, withdrawing for a home buyers plan or transferring to a RRIF. Please contact support to facilitate the transfer of funds"
  }
}
